import { render, staticRenderFns } from "./Dataimport.vue?vue&type=template&id=b620d208&scoped=true&"
import script from "./Dataimport.vue?vue&type=script&lang=js&"
export * from "./Dataimport.vue?vue&type=script&lang=js&"
import style0 from "./Dataimport.vue?vue&type=style&index=0&id=b620d208&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b620d208",
  null
  
)

export default component.exports